export interface GetAccountNumberInfoByNumber {
	accountType: string;
	accountId: string;
	accountNum: string;
	billingType: string;
	addBillingType: string;
}

const model: types.models.InputModel = {
	accountType: 'response.GetAccountNumberInfoByNumberResponse.Row.ACCOUNT_TYPE',
	accountId: 'response.GetAccountNumberInfoByNumberResponse.Row.ACCOUNT_ID',
	accountNum: 'response.GetAccountNumberInfoByNumberResponse.Row.ACCOUNT_NUM',
	billingType: 'response.GetAccountNumberInfoByNumberResponse.Row.BILLING_TYPE',
	addBillingType: 'response.GetAccountNumberInfoByNumberResponse.Row.ADD_BILLING_TYPE',
};

export default model;
